/**
 * KEEP THIS FILE IN SYNC WITH THE SERVER VERSION
 * (server/common/SupportedLanguages.ts)
 */

export const kSupportedLanguages = ['en', 'it', 'ro'] as const;

export type SupportedLanguage = typeof kSupportedLanguages[number];
